import React, { useEffect, useRef, useState } from "react";
import "./styles/dashboard.css";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import CommonHeader from "./components/CommonHeader";

const AddBooking = () => {
  const navigate = useNavigate();

  const [pickLoc, setPicLoc] = useState([]);
  const [drop, setDrop] = useState([]);
  const [times, setTimes] = useState([]);
  const [agency, setAgency] = useState([]);
  let trigger = true;

  // Help/FAQ popup
  const [showHelpFaqModal, setShowHelpFaqModal] = useState(false);
  const [helpLoading, setHelpLoading] = useState(false);
  const [helpHtml, setHelpHtml] = useState("");
  const [faqHtml, setFaqHtml] = useState("");

  const helpContentRef = useRef(null);
  const faqContentRef = useRef(null);

  useEffect(() => {
    if (!helpContentRef.current || !faqContentRef.current) return;
    // Inject HTML returned by backend as-is.
    helpContentRef.current.innerHTML = helpHtml || "";
    faqContentRef.current.innerHTML = faqHtml || "";
  }, [helpHtml, faqHtml]);

  const fetchHelpFaqForBooking = async () => {
    setHelpLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/HelpFaq/getHelpFaqForBooking`,
        {
          method: "post",
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        }
      );

      const resp = await res.json();
      if (resp.status === 1) {
        setHelpHtml(resp.help_html || "");
        setFaqHtml(resp.faq_html || "");
      } else {
        toast.error(resp.message || "Failed to load Help/FAQ");
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load Help/FAQ");
    } finally {
      setHelpLoading(false);
    }
  };

  // Function to convert text to uppercase
  const handleUpperCase = (e) => {
    e.target.value = e.target.value.toUpperCase();
  };

  useEffect(() => {

    fetch(`${process.env.REACT_APP_API_URL}/suggests/getagencies?da=` + new Date(), {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: [],
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);

      if (resp.list) {


        if (trigger) {
          resp.list.forEach((value) => {
            agency.push({ value: value.agency_name, label: value.agency_name });
          });

          trigger = false;
        }



      }
    });

    fetch(`${process.env.REACT_APP_API_URL}/suggests/getpickuplocations?da=` + new Date(), {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: [],
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);

      if (resp.list) {
        setPicLoc(resp.list);
      }
    });

    fetch(`${process.env.REACT_APP_API_URL}/suggests/getdroppoints?da=` + new Date(), {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: [],
    }).then(async (res) => {
      let resp = await res.json();
      console.log(resp);

      if (resp.list) {
        setDrop(resp.list);
      }
    });

    fetch(`${process.env.REACT_APP_API_URL}/suggests/getbustimings?da=` + new Date(), {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: [],
    }).then(async (res) => {
      let resp = await res.json();
      if (resp.message === "OK") {
        setTimes(resp.list);
        console.log(resp);
      } else {
        toast.error(resp.message);
      }
    });
  }, []);

  function handleSubmit(e) {
    e.preventDefault();

    const data = new URLSearchParams();
    for (const pair of new FormData(
      document.getElementById("addBookingForm")
    )) {
      data.append(pair[0], pair[1]);
    }

    const flightTimeElement = document.getElementById("flight-time");
    if (flightTimeElement) {
      data.set(
        "flight_time",
        flightTimeElement.value.replace("T", " ")
      );
    }

    fetch(`${process.env.REACT_APP_API_URL}/booking/addbooking`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: data,
    }).then(async (res) => {
      let resp = await res.json();

      console.log(resp);

      if (resp.message === "Added") {
        toast.success("Booking created");
        navigate("/bookings");
      } else {
        toast.error(resp.message);
      }
    });
  }

  return (
    <>
      <div class="d-flex flex-column flex-lg-row h-lg-full bg-surface-secondary">
        <div class="h-screen flex-grow-1 overflow-y-lg-auto">
          <CommonHeader />
          <main class="py-6 bg-surface-secondary">
            <div class="container-fluid">
              <div
                style={{ padding: "1rem", backgroundColor: "white" }}
                className="card shadow border-0"
              >
                <div class="d-flex justify-content-end mb-2">
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm"
                    onClick={() => {
                      setShowHelpFaqModal(true);
                      // Clear old content immediately so the modal doesn't flash stale HTML.
                      setHelpHtml("");
                      setFaqHtml("");
                      fetchHelpFaqForBooking();
                    }}
                    title="Help / FAQ"
                  >
                    Help / FAQ
                  </button>
                </div>
      <form class="row g-3" onSubmit={handleSubmit} id="addBookingForm">
        <div class="col-12">
          <label class="form-label">Pax Name</label>

          <input
            type="text"
            class="form-control shadow-none"
            name="pax_name"
            placeholder="Enter pax name"
            onInput={handleUpperCase}
          />
        </div>
        <div class="col-12">
          <label for="inputAddress" class="form-label">
            Mobile No.
          </label>
          <input
            type="text"
            class="form-control shadow-none"
            name="pax_contact_no"
            maxLength={30}
            placeholder="Enter pax contact number"
          />
        </div>

        <div class="col-12" style={{ position: "relative" }}>
          <label for="inputAddress" class="form-label">
            Agency Name
          </label>

          {/*   <input
            autoComplete="off"
            id="agency_name"
            type="text"
            class="form-control shadow-none"
           name="agency_name"
            placeholder="Enter agency name"
  /> */}

<CreatableSelect
            isClearable
            options={agency}
            placeholder="Enter agency name"
            id="agency_name"
            name="agency_name"
            onInputChange={(inputValue) => inputValue.toUpperCase()}
            onChange={(option) => {
              if (option && option.value) {
                option.value = option.value.toUpperCase();
              }
            }}
          />


        </div>

        <div class="col-12">
          <label for="inputAddress2" class="form-label">
            Pickup Point
          </label>

          {/* <input
            type="text"
            class="form-control shadow-none"
            name="role_fk"
            id="inputAddress2"
            placeholder="Enter user role"
          /> */}

          <select class="form-select shadow-none" name="pickup_location_name">
            <option selected value={""}>
              Choose...
            </option>
            {pickLoc.length !== 0 ? (
              pickLoc.map((role) => {
                return (
                  <option value={role.pickup_point_name}>
                    {role.pickup_point_name}
                  </option>
                );
              })
            ) : (
              <option value={""}>...</option>
            )}
          </select>
        </div>

        <div class="col-md-6">
          <label for="inputAddress2" class="form-label">
            Sub Pickup Point
          </label>

          <input
            type="text"
            class="form-control shadow-none"
            name="sub_pickup"
            onInput={handleUpperCase}
          />
        </div>

        <div class="col-12">
          <label class="form-label" htmlFor="sub_pickup_location_details">
            Sub pickup location link{" "}
            <span class="text-muted fw-normal">(optional)</span>
          </label>
          <textarea
            id="sub_pickup_location_details"
            name="sub_pickup_location_details"
            class="form-control shadow-none"
            rows={3}
            placeholder="Google Maps link (single line)"
          />
        </div>

        <div class="col-md-6">
          <label for="inputAddress2" class="form-label">
            Pickup Date
          </label>

          {/* <input
            type="text"
            class="form-control shadow-none"
            name="role_fk"
            id="inputAddress2"
            placeholder="Enter user role"
          /> */}

          <input
            type="date"
            class="form-control shadow-none"
            name="pickup_date"
          />
        </div>

        

        <div class="col-12">
          <label for="inputAddress" class="form-label">
            Drop Point
          </label>

          <select class="form-select shadow-none" name="drop_point_name">
            <option selected value={""}>
              Choose...
            </option>
            {drop.length !== 0 ? (
              drop.map((role) => {
                return (
                  <option value={role.drop_point_name}>
                    {role.drop_point_name}
                  </option>
                );
              })
            ) : (
              <option value={""}>...</option>
            )}
          </select>
        </div>

        <div class="col-md-6">
          <label for="inputAddress2" class="form-label">
            Flight Time
          </label>

          {/* <input
            type="text"
            class="form-control shadow-none"
            name="role_fk"
            id="inputAddress2"
            placeholder="Enter user role"
          /> */}

          <input
            type="datetime-local"
            class="form-control shadow-none"
            name="flight_time"
            id="flight-time"
          />
        </div>

        <div class="col-md-6">
          <label for="inputAddress2" class="form-label">
            Bus Time
          </label>

          <select class="form-select shadow-none" name="bus_time_id">
            <option selected value={""}>
              Choose...
            </option>
            {times.length !== 0 ? (
              times.map((role) => {
                return <option value={role.time_id}>{role.time_name}</option>;
              })
            ) : (
              <option value={""}>...</option>
            )}
          </select>
        </div>

        <div class="col-12">
          <label for="inputAddress" class="form-label">
            Remarks
          </label>
          <input
            type="text"
            class="form-control shadow-none"
            name="remarks"
            placeholder="Optional"
            onInput={handleUpperCase}
          />
        </div>

        <div class="col-12 mt-8">
          <button
            class="btn d-inline-flex btn-sm btn-neutral mx-1"
            onClick={() => navigate("/bookings")}
          >
            <span class=" pe-2">
              <i class="bi bi-arrow-left"></i>
            </span>
            <span>Back</span>
          </button>
          <button type="submit" class="btn btn-primary btn-sm mx-1">
            Add Booking
          </button>
        </div>
      </form>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Help/FAQ Modal */}
      {showHelpFaqModal && (
        <div
          class="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Help / FAQ</h5>
                <button
                  type="button"
                  class="btn-close"
                  onClick={() => {
                    setShowHelpFaqModal(false);
                    setHelpHtml("");
                    setFaqHtml("");
                  }}
                ></button>
              </div>
              <div class="modal-body">
                {helpLoading ? (
                  <div>Loading...</div>
                ) : (
                  <>
                    <div class="mb-3">
                      <h6 class="mb-2">Help</h6>
                      <div ref={helpContentRef} />
                    </div>
                    <div>
                      <h6 class="mb-2">FAQ</h6>
                      <div ref={faqContentRef} />
                    </div>
                  </>
                )}
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  onClick={() => {
                    setShowHelpFaqModal(false);
                    setHelpHtml("");
                    setFaqHtml("");
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddBooking;
